import { SerializedStyles, css } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface SelectionNestedWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

export const SelectionNestedWrapper = withConfig(theme => styled('div', { label: 'SelectionNestedWrapper' })<SelectionNestedWrapperPropsType>`
    border-left: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? 'none': `1px solid ${theme.star.selectionsGroup.borderColor}`};
    display: flex;
    flex-flow: column nowrap;
`);

interface SelectionRabItemMenuPropsType {
    variant: DefaultComponentVariantType | null;
}

const setSelectionRabItemMenu = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            padding: ${theme.star.padding.medium} 0;
        `;
    }
    return css`
        border-color: ${theme.star.selectionsGroup.borderColor};
        border-style: solid;
        border-width: 0 1px 1px 1px;
        padding: ${theme.star.padding.medium};
    `;
};

export const SelectionRabItemMenu = withConfig(theme => styled('ul', { label: 'SelectionRabItemMenu' })<SelectionRabItemMenuPropsType>`
    ${({ variant }): SerializedStyles=> setSelectionRabItemMenu(variant, theme)};
    background: ${theme.star.marketGroupGoalscorer.filters.bgColor};
    display: flex;
`);
